import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const MobilePartnerBanner = ({ label = "For educators & institutes", title = "Is your institute unranked?", text = "Claim your official profile, list your courses and reach more students with real community feedback.", button = "Claim & list your institute", link = "/register?role=institute", testId = "mobile-partner-banner" }) => (
  <section className="mobile-partner-banner" data-testid={testId}>
    <span className="mobile-eyebrow">{label}</span>
    <h2>{title}</h2><p>{text}</p>
    <Link data-testid={`${testId}-link`} to={link} className="mobile-primary">{button}<ArrowRight size={17} /></Link>
  </section>
);
